import React from 'react';
import { createPortal } from 'react-dom';
import { useTour } from './TourContext';
import { pasosRegistro, pasosAlta, pasosAlmacen, pasosPublicacion, pasosReserva } from './TourContext';
import './TourMenu.css';

const IconRegistro = () => (
  <svg viewBox="0 0 24 24" width="28" height="28" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
    <circle cx="12" cy="7" r="4" />
    <path d="M16 3.13a4 4 0 0 1 0 7.75" />
    <path d="M21 21v-2a4 4 0 0 0-3-3.87" />
  </svg>
);

const IconEmpresa = () => (
  <svg viewBox="0 0 24 24" width="28" height="28" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <rect x="2" y="7" width="20" height="14" rx="2" />
    <path d="M16 7V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v2" />
    <line x1="12" y1="12" x2="12" y2="16" />
    <line x1="10" y1="14" x2="14" y2="14" />
  </svg>
);

const IconAlmacen = () => (
  <svg viewBox="0 0 24 24" width="28" height="28" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <path d="M2 20V9.5L12 3l10 6.5V20H2z" />
    <rect x="8" y="13" width="8" height="7" />
    <line x1="12" y1="13" x2="12" y2="20" />
  </svg>
);

const IconPublicacion = () => (
  <svg viewBox="0 0 24 24" width="28" height="28" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <path d="M3 11V8a1 1 0 0 1 1-1h12l4-3v14l-4-3H4a1 1 0 0 1-1-1v-3z" />
    <path d="M7 11v4" />
  </svg>
);

const IconReserva = () => (
  <svg viewBox="0 0 24 24" width="28" height="28" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
    <line x1="16" y1="2" x2="16" y2="6" />
    <line x1="8" y1="2" x2="8" y2="6" />
    <line x1="3" y1="10" x2="21" y2="10" />
    <path d="M8 14h.01M12 14h.01M16 14h.01M8 18h.01M12 18h.01" />
  </svg>
);

const IconArrow = () => (
  <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M5 12h14" />
    <path d="m12 5 7 7-7 7" />
  </svg>
);

const IconCerrar = () => (
  <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <line x1="18" y1="6" x2="6" y2="18" />
    <line x1="6" y1="6" x2="18" y2="18" />
  </svg>
);

const opciones = [
  {
    id: 'registro',
    titulo: 'Cómo registrarme',
    descripcion: 'Crea tu cuenta paso a paso, con correo electrónico o directamente con Google y Facebook.',
    pasos: pasosRegistro,
    icono: <IconRegistro />,
    badge: `${pasosRegistro.length} pasos`,
  },
  {
    id: 'alta',
    titulo: 'Dar de alta una empresa',
    descripcion: 'Registra tu empresa o persona física para publicar tus almacenes y empezar a ganar.',
    pasos: pasosAlta,
    icono: <IconEmpresa />,
    badge: `${pasosAlta.length} pasos`,
  },
  {
    id: 'almacen',
    titulo: 'Dar de alta un almacén',
    descripcion: 'Registra tu espacio de almacenaje: tipo, domicilio, horarios, vehículos, servicios, documentos y fotos.',
    pasos: pasosAlmacen,
    icono: <IconAlmacen />,
    badge: `${pasosAlmacen.length} pasos`,
  },
  {
    id: 'publicacion',
    titulo: 'Crear una publicación',
    descripcion: 'Publica tu almacén: define el tipo de espacio, precio por periodo, política de cancelación y ponla a la vista de los clientes.',
    pasos: pasosPublicacion,
    icono: <IconPublicacion />,
    badge: `${pasosPublicacion.length} pasos`,
  },
  {
    id: 'reserva',
    titulo: 'Cómo reservar un almacén',
    descripcion: 'Aprende a buscar, seleccionar y reservar un espacio de almacenaje: buscador, fechas, espacios, datos de contacto y pago.',
    pasos: pasosReserva,
    icono: <IconReserva />,
    badge: `${pasosReserva.length} pasos`,
  },
];

const TourMenu = ({ onClose }) => {
  const { iniciarTour } = useTour();

  const handleIniciar = (pasos) => {
    iniciarTour(pasos);
    onClose();
  };

  return createPortal(
    <div className="tour-menu-overlay" onClick={onClose} role="dialog" aria-modal="true" aria-label="Centro de ayuda">
      <div className="tour-menu" onClick={e => e.stopPropagation()}>
        {/* Header */}
        <div className="tour-menu-header">
          <div className="tour-menu-header-text">
            <span className="tour-menu-pretitulo">PalletCloud</span>
            <h2 className="tour-menu-titulo">Centro de ayuda</h2>
          </div>
          <button className="tour-menu-cerrar" onClick={onClose} aria-label="Cerrar">
            <IconCerrar />
          </button>
        </div>

        <p className="tour-menu-subtitulo">Selecciona un tutorial y te guiamos paso a paso.</p>

        {/* Opciones */}
        <div className="tour-menu-opciones">
          {opciones.map(opcion => (
            <button
              key={opcion.id}
              className="tour-menu-card"
              onClick={() => handleIniciar(opcion.pasos)}
            >
              <div className="tour-menu-card-icono">
                {opcion.icono}
              </div>
              <div className="tour-menu-card-info">
                <div className="tour-menu-card-top">
                  <h3 className="tour-menu-card-titulo">{opcion.titulo}</h3>
                  <span className="tour-menu-card-badge">{opcion.badge}</span>
                </div>
                <p className="tour-menu-card-desc">{opcion.descripcion}</p>
              </div>
              <div className="tour-menu-card-arrow">
                <IconArrow />
              </div>
            </button>
          ))}
        </div>
      </div>
    </div>,
    document.body
  );
};

export default TourMenu;
